<template>
  <div>
    <div v-if="$route.path.indexOf('_editor') === -1 && $route.path.indexOf('_wechatlog') === -1 && $route.path.indexOf('_userlog') === -1 ">
      <el-row>
        <el-button size="mini" type="text" @click="goUrl('/marketing/newCustomer/newCustomer_wechatlog')">社群记录列表</el-button>
        <el-button size="mini" type="text" @click="goUrl('/marketing/newCustomer/newCustomer_userlog')">用户记录列表</el-button>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="block">
                <el-input  size="mini" v-model="params.name" placeholder="标题" ></el-input>
              </div>
          </el-col>
        <el-col :span="6">
          <div class="block">
            <el-date-picker size="mini" v-model="params.times" clearable type="daterange" :picker-options="pickerOptions"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="7">
          <el-button type="primary" @click="searchData" size="mini">搜索</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-button size="mini" type="danger" @click="create()">新增+</el-button>
      </el-row>

      <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
        <el-table-column label="类型">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type == 1" type="success"> 新客专区</el-tag>
            <el-tag v-else type="danger">社群专区</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="活动标题"></el-table-column>
        <el-table-column label="开始时间" prop="start_time_text">
        </el-table-column>
        <el-table-column label="结束时间" prop="end_time_text">
        </el-table-column>
        <el-table-column prop="user_one_limit" label="参与次数限制"></el-table-column>
        <el-table-column prop="user_all_limit" label="活动总人数限制"></el-table-column> 
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="create(scope.row.id)">编辑</el-button>
            <el-button size="mini" type="danger" @click="del(scope.row.id, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="content-center content-top-padded">
        <el-pagination background layout="total, sizes, prev, pager, next" @current-change="handleCurrentChange"
          @size-change="handleSizeChange" :current-page.sync="params.page" :page-sizes="[10, 20, 50]" :total="total_count"
          :page-size="params.pagesize">
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import {
  mapGetters
} from "vuex";
import draggable from "vuedraggable";
import {
  getNewCustomerList,  delNewCustomer
} from "@/api/promotions";
export default {
  components: {
    draggable
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      dialogVisible: false,
      total_count: 0,
      params: {
        page: 1,
        pagesize: 20,
      },
      dataList: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
  },
  methods: {
    goUrl(url) {
      this.$router.push({ path:url });
    },
    create(id = '') {
      if (!id) {
        this.$router.push({ path: "/marketing/newCustomer/newCustomer_editor" });
      } else {
        this.$router.push({
          path: "/marketing/newCustomer/newCustomer_editor",
          query: { id: id },
        });
      }
    },
    getDataList() {
      this.loading = true;
      getNewCustomerList(this.params)
        .then((response) => {
          this.dataList = response.data.data.list;
          this.total_count = response.data.data.total_count;
          this.loading = false;
        })
    },
    del(id, index) {
      this.$confirm('确定删除么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delNewCustomer(id).then(response => {
          this.$message({
            type: "success",
            message: response.data.data.msg,
          })
          this.dataList.splice(index, 1);
        })
      });
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num;
      this.getDataList();
    },
    searchData() {
      this.params.page = 1;
      this.getDataList();
    },
    handleSizeChange(pageSize) {
      this.params.page = 1;
      this.params.pagesize = pageSize;
      this.getDataList();
    },
  },
  mounted() {
    this.getDataList();
  },
  provide() {
    return {
      refresh: this.getDataList
    }
  },

};
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// list.vue?7385dd0e